import multiselect from './multiselect.json';
import releaseNotes from './releaseNotes.json';
import support from './support.json';
import tempo from './tempo.json';
import hub from './hub.json';
import extensionModule from './extensionModule.json';
import conditionRow from './conditionRow.json';
import actionRow from './actionRow.json';
import externalInput from './externalInput.json';
import externalAlarmInput from './externalAlarmInput.json';
import integration from './integration.json';
import video from './video.json';
import meca from './meca.json';
import facilityComponents from './facilityComponents.json';
import weekDay from './weekDay.json';
import action from './action.json';
import condition from './condition.json';
import datatables from './datatables.json';

export default {
  releaseNotes,
  support,
  multiselect,
  tempo,
  hub,
  extensionModule,
  conditionRow,
  actionRow,
  externalInput,
  externalAlarmInput,
  integration,
  video,
  meca,
  facilityComponents,
  weekDay,
  action,
  condition,
  datatables,
};
